import { Close } from '@mui/icons-material';
import { IconButton, Typography, Stack, Box } from '@mui/material';

const CommonAttachmentMedia = ({
    image,
    title,
    size,
    isImage,
    isDelete,
    deleteImage,
    removeImage,
    index,
    isFile,
    isDownload,
    downloadUrl
}) => {
    const handleDelete = () => {
        if (isFile) deleteImage(index);
        else removeImage(index);
    };
    const handleDownloadImage = () => {
        const fileUrl = downloadUrl;
        // Specify the filename for the download
        const link = document.createElement('a');
        link.href = fileUrl;
        // Open the link in a new tab
        window.open(link.href, '_blank');
    };
    const handleDowload = async () => {
        if (isDownload) {
            if (isImage) {
                handleDownloadImage();
                return;
            }
            try {
                const fileUrl = downloadUrl;

                // Fetch the file as a binary blob
                const response = await fetch(fileUrl);
                const blob = await response.blob();

                // Create a Blob object and generate a URL
                const blobUrl = window.URL.createObjectURL(blob);

                // Create a temporary link element
                const link = document.createElement('a');
                link.href = blobUrl;

                // Specify the filename for the download
                link.download = title;

                // Append the link to the document body
                document.body.appendChild(link);

                // Trigger the click event to start the download
                link.click();

                // Remove the link and revoke the URL
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            } catch (e) {
                console.log('Downloading error', e.message);
            }
        }
    };
    return (
        <Box className="media-attachment text-cursored" onClick={() => handleDowload()}>
            {/* <Stack direction={'row'} justifyContent={'space-between'} alignContent={'center'} alignItems={'center'} spacing={2}>
                {isImage ? <img src={image} alt="attachment-media" width={50} height={'auto'} /> : <img src={image} alt="attachment-pdf" />}
                <div>
                    <Typography component="p" variant="p" className="custom-card-attachment-media-text">
                        {title}
                    </Typography>

                    <Typography className="custom-card-attachment-media-text" variant="body">
                        {size} KB
                    </Typography>
                </div>
                {isDelete && (
                    <IconButton onClick={handleDelete} sx={{ marginLeft: 'auto' }}>
                        {' '}
                        <Close />{' '}
                    </IconButton>
                )}
            </Stack> */}

            <Stack flexDirection="row" flexWrap={'wrap'}>
                <Box className={`${isImage ? 'icon-wrap media-img-wrap' : 'icon-wrap'}`}>
                    {isImage ? (
                        <img src={image} alt="attachment-media" width={50} height={'auto'} />
                    ) : (
                        <img src={image} alt="attachment-pdf" width="24" height="29" />
                    )}
                </Box>

                <Box className={`${isImage ? 'text-wrap media-text-wrap' : 'text-wrap'}`}>
                    <Typography style={{ marginBottom: '3px' }} className="text-ellipsis" title={title}>
                        {title}
                    </Typography>
                    <Typography>{size}</Typography>
                </Box>

                {isDelete && (
                    <IconButton onClick={handleDelete} sx={{ marginLeft: 'auto' }}>
                        <Close />
                    </IconButton>
                )}
            </Stack>
        </Box>
    );
};
export default CommonAttachmentMedia;
